import React, { useEffect, useState } from 'react';
import LoadingManager from './LoadingManager';
import './Loader.scss';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
    globalLoader: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
}));

export const GlobalLoader: React.FC = () => {
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const manager = LoadingManager.getInstance();

        const updateLoadingState = () => {
            setIsLoading(manager.isLoading());
        };

        // Subscribe to loading state changes
        const unsubscribe = manager.subscribe(updateLoadingState);

        // Set initial state
        updateLoadingState();

        return unsubscribe;
    }, []);

    if (!isLoading) {
        return null;
    }

    return (
        <div
            className={classNames(
                'Loader',
                'Loader--global',
                classes.globalLoader,
            )}
            data-testid="GlobalLoader"
            aria-busy="true"
            role="status"
        >
            <div className="Loader-wrapper">
                <div className="Loader-circles" />
            </div>
        </div>
    );
};
